<template>
  <div class="home-leaflet-unit" data-hleaf090343="none">
    <slot></slot>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";

import markerDefaultBlue from "@/assets/images/map/mark_default_blue.png";
import robotGrey from "@/assets/images/map/robot_grey2.png";
import robotBlue from "@/assets/images/map/robot_blue2.png";
import langMap from '@/utils/language';
import mapIntersectionUtil from '@/utils/mapIntersectionUtil';

// 弹框列表
let popUpList = {};

export default {
  name: "leafletRobot",
  props: {
    // 绘制区域用的颜色集
    areaColor: {
      type: Array,
      default: () => ['', '', '']
    },
    // 历史路径颜色
    trackColor: {
      type: String,
      default: '#AB8B54'
    },
    mapContainerID: {
      type: String,
      default: 'map'
    }
  },
  data() {
    return {
      langMap:langMap,
      defaultMap: "", //默认地图，高德amap，通用地图leaflet，默认通用地图；
      defaultMapUrl: "", //默认地图url，通用地图默认url
      placeSearch: null,
      map: null,
      robots: [],
      robotsLayer: [],
      seat: [],
      taskType: "",
      robotsData: [], // 存
      timer: null, //
      areaList: [],
      tableLoading: false,
      areaLayers: [], // 添加用于存储区域图层的数组
      intersectionLayers: [], // 添加用于存储交叉区域图层的数组
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      mapConfig: state => state.app.leafletConfig
    })
  },
  methods: {
    //初始化地图
    initMap(mapkey,mapurl) {
      const tileLayerOption = this.mapConfig.tileLayerOption
      this.map = L.map(this.mapContainerID, this.mapConfig.mapInstantiated);
      L.tileLayer(tileLayerOption.url, tileLayerOption).addTo(this.map);

      //添加绘制控制组件
      this.map.pm.setLang(this.lang || 'zh');
      this.map.pm.addControls({
        position: "topleft",
        drawPolygon: false, // 绘制多边形
        drawMarker: false, //绘制标记点
        drawCircleMarker: false, //绘制圆形标记
        drawPolyline: false, //绘制线条
        drawRectangle: false, //绘制矩形
        drawCircle: false, //绘制圆圈
        editMode: false, //编辑多边形
        dragMode: false, //拖动多边形
        cutPolygon: false, // 添加一个按钮以删除多边形里面的部分内容
        removalMode: false // 清除多边形
      });
    },
    //初始化绘制区域
    initTargetArea(areaList) {
      const dataList = areaList || [];
      this.areaLayers = []; // 清空现有图层
      dataList.forEach((item, index) => {
        if (item.area !== null) {
          let color = this.areaColor[item.type];

          let areas = JSON.parse(item.area);
          let areaTemp = [];
          areas.forEach((item1, index1, arr1) => {
            let point = [item1.lat, item1.lon];
            areaTemp[index1] = point;
          });

          let polygon = L.polygon(areaTemp, {
            color: color,
            id: item.id,
            type: item.type, // 确保类型信息存在
            createTime: item.createTime, // 确保创建时间信息存在
            stationId: item.stationId, // 添加 stationId
            layerPriority: item.layerPriority || 0,     // 添加 mapSort
          }).addTo(this.map);

          // 保存到图层数组中
          this.areaLayers.push(polygon);
          // let _this = this;
          // //弹出信息层
          // polygon.on('click', (e)=> {
          //   _this.createPopup(item.tempId)
          // });
        }
      });
       // 3. 计算并显示交叉区域
       this.findAndDisplayIntersections();
    },
    //绘制任务路径
    initTask(robot) {
      if (!robot || !robot.executeTask || !robot.executeTask.task) {
        return;
      }

      //查找层
      let layer;
      let order;
      this.robotsLayer.forEach((item, index, arr) => {
        if (item.id === robot.id) {
          layer = item;
          order = index;
        }
      });
      //多条路径
      robot.executeTask.task.paths.forEach((path, index1) => {
        //绘制点
        let markerPoints = [];
        let taskMarker = [];
        path.nodes.forEach((item, index) => {
          if (item.lat !== null && item.lng !== null) {
            let marker;
            let point = [item.lat, item.lng];
            markerPoints.push(point);
            marker = L.marker(point, {
              icon: L.icon({
                iconUrl: markerDefaultBlue,
                iconSize: [12, 12],
                iconAnchor: [6, 6] //icon图标点位置偏移
              }),
              title: item.name,
              draggable: false,
              id: item.id
            }).addTo(this.map);

            taskMarker.push(marker);
          }
        });

        //绘制线
        let line;
        line = L.polyline(markerPoints, {
          opacity: 1, //透明度
          color: "blue"
        }).addTo(this.map);

        if (!layer) {
          let taskPath = [];
          taskPath.push(line);
          let taskMarkers = [];
          taskMarkers.push(taskMarker);
          this.robotsLayer.push({
            id: robot.id,
            taskPath: taskPath,
            taskMarker: taskMarkers
          });
        } else {
          let taskPath = layer.taskPath || [];
          taskPath.push(line);
          let taskMarkers = layer.taskMarker || [];
          taskMarkers.push(taskMarker);
          layer = {
            ...layer,
            id: robot.id,
            taskPath: taskPath,
            taskMarker: taskMarkers
          };
          this.$set(this.robotsLayer, order, layer);
        }
      });
    },
    //绘制任务已经执行的路径
    drawHistoryPath(robot) {
      //查找层
      let layer;
      let order;
      const points = robot.hisPoints;

      this.robotsLayer.forEach((item, index, arr) => {
        if (item.id === robot.id) {
          layer = item;
          order = index;
        }
      });

      if (layer && layer.hisPath) {
        this.map.removeLayer(layer.hisPath);
      }

      if (!robot.hisPoints.length) {
        return;
      }

      let path = [];
      const len = points.length;
      for (let i = 0,item; i < len; i++){
        item = points[i];
        path.push({ x:item.var2, y:item.var1 });
      }

      /*使用simplify.js简化后的路径（去除部分不必要的点）*
        第二个参数越大则去除的点越多
      */
      const simplifyPath = L.LineUtil.simplify(path, 0.000005);

      // 处理为leaflet使用的点
      let finishPath = [];
      for (let i = 0, item; i < simplifyPath.length; i++) {
        item = simplifyPath[i];
        finishPath.push([item.x,item.y]);
      }
      let _config = this.mapConfig;
      let mapPolyline = L.polyline(finishPath, {
        opacity: 1, //透明度
        stroke: true, // 线周围绘制边框
        color: _config.trackColor,
        weight: _config.trackWidth+2
      }).addTo(this.map);

      if (!layer) {
        this.robotsLayer.push({
          id: robot.id,
          hisPath: mapPolyline
        });
      } else {
        layer = { ...layer, id: robot.id, hisPath: mapPolyline };
        this.$set(this.robotsLayer, order, layer);
      }
    },
    moveToCenter(point) {
      // 注意坐标是否相反
      this.map.panTo([point[1], point[0]]);
    },
    //绘制或更新机器人实时位置
    drawOrUpdateRobotPosition(robot) {
      //查找层
      let layer;
      let order;
      const ROBOT_ID = robot.id;
      const lastPosition = robot.lastPosition;
      //console.info('[lastPosition---]', lastPosition);
      this.robotsLayer.forEach((item, index, arr) => {
        if (item.id === ROBOT_ID) {
          layer = item;
          order = index;
        }
      });
      if (layer && layer.marker) {
        this.map.removeLayer(layer.marker);
      }

      if (lastPosition) {
        let robotIconUrl = robot.status === 1 ? robotBlue : robotGrey;
        let marker;

        let icon = new L.divIcon({
          html:
            '<div style="width: 100px;font-size: 12px;font-weight: 700;color: red;">' +
            robot.name +
            '</div><img src="' +
            robotIconUrl +
            '" style="width: 20px;height: 20px;" />',
          className: "my-div-icon",
          iconAnchor: [6, 28]
        });
        // leaflet坐标与amap相反
        marker = L.marker([lastPosition[1], lastPosition[0]], {
          icon: icon,
          title: robot.name,
          draggable: false,
          zIndexOffset: 1000,
          id: ROBOT_ID
        }).addTo(this.map);
        // 添加描述
        let content = this.genContent(robot);
        // 该机器人已创建过窗口则将其关闭
        if (popUpList[ROBOT_ID]) popUpList[ROBOT_ID].close();
        popUpList[ROBOT_ID] = L.popup({
          offset: L.point(0, -15),
          autoClose: false, // 开启另一个弹框时不关闭
        }).setLatLng([lastPosition[1], lastPosition[0]]).setContent(content).openOn(this.map);

        /*弹出信息层
        marker.on('click', (e)=>{
          this.createPopup(item.id);
        });*/

        if (!layer) {
          this.robotsLayer.push({ id: robot.id, marker: marker });
        } else {
          layer = { ...layer, id: robot.id, marker: marker };
          this.$set(this.robotsLayer, order, layer);
        }
      }
    },
    genContent(robot) {
      let html =
        '<div class="input-card content-window-card"><div style="padding:2px;"><h4>' +
        robot.name +
        "</h4>" +
        '<div class="input-item">' + langMap.power[this.lang] + ':' +
        (robot.statusData && robot.statusData.stateOfCharge && robot.statusData.stateOfCharge.value ? robot.statusData.stateOfCharge.value : "-") +
        "</div>" +
        '<div class="input-item">' + langMap.speedHtml[this.lang] + ':' +
        (robot.movementData ? robot.movementData.speed : "-") +
        "/" + langMap.direction[this.lang] + ":" +
        (robot.movementData ? robot.movementData.direction : "-") +
        "</div>";
      return html;
    },
    // 4. 添加计算并显示交叉区域的方法
    findAndDisplayIntersections() {
      // 使用工具类计算并显示交叉区域
      this.intersectionLayers = mapIntersectionUtil.findAndDisplayIntersections(
        this.map,
        this.areaLayers,
        this.intersectionLayers
      );
    }
  }
};
</script>
<style lang="less">
.home-leaflet-unit[data-hleaf090343]{
  height: 100%;

  .leaflet-fade-anim{
    .leaflet-popup{
      transition: none;
      -webkit-transition: none;
    }
  }
  .leaflet-popup-content{margin:5px;}
}

</style>
